import { IconButton, Tooltip } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import { useMatch } from 'react-router-dom';

import { CommandKeybindingsTooltipContent } from 'components/commandKeybindingsTooltipContent';
import { useCommandHandler } from 'utils/commands';
import { useAppNavigate } from 'utils/url/useAppNavigate';
import { useAppPathParams } from 'utils/url/useAppPathParams';

export const ConversationActivityLogButton = (): JSX.Element => {
  const activityLogMatch = useMatch('/conversation/:csid/activity-log');
  const conversationMatch = useAppPathParams('/conversation/:csid');
  const isActivityLogOpen = Boolean(activityLogMatch);
  const navigate = useAppNavigate();

  useCommandHandler({
    name: 'conversation:activityLog',
    actionFn: () => {
      toggleActivityLog();
    },
  });

  const toggleActivityLog = () => {
    // conversation match will match either case, conv. or activity log
    // if there is no match something is wrong and we should not proceed
    if (!conversationMatch.csid) return;
    const csid = conversationMatch.csid;

    if (isActivityLogOpen) {
      navigate({
        path: '/conversation/:csid',
        params: { path: { csid } },
      });
    } else {
      navigate({
        path: '/conversation/:csid/activity-log',
        params: { path: { csid } },
      });
    }

    if (isActivityLogOpen) {
      ampli.conversationActivityLogOpened({ context: 'conversation' });
    } else {
      ampli.conversationActivityLogClosed();
    }
  };

  const tooltipContent = (
    <CommandKeybindingsTooltipContent commandName="conversation:activityLog">
      Activity log
    </CommandKeybindingsTooltipContent>
  );

  return (
    <Tooltip content={tooltipContent}>
      <IconButton
        data-testid="activity-log-button"
        icon="activity"
        variant="tertiary"
        active={isActivityLogOpen}
        onClick={toggleActivityLog}
      />
    </Tooltip>
  );
};
